import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Icon from '../Icons/Icon';
import { CompletedTrue, CompletedFalse } from '../Icons/Icons';
import tailwindTheme from '../../../../../config/tailwind.config';

const ImportChooseFileArea = ({
  droppedFile, setDroppedFile, isValidExtension, setIsValidExtension, setIsDisabled,
}) => {
  const [fileOverBox, setFileOverBox] = useState(false);
  const handleDrop = (event) => {
    event.preventDefault();
    if (droppedFile) {
      return;
    }

    // droppedFiles is a FileList object from the event
    const droppedFiles = event.dataTransfer.files;
    if (droppedFiles.length === 0) return;
    // handle dropped file/files.
    // If dropped more than 1 file - handle first file in the array
    const newFiles = Array.from(droppedFiles);
    // if user drops more than one file, only take the first one
    setDroppedFile(newFiles[0]);
    // validate file type
    const eventFileType = newFiles[0].type === 'text/csv';
    // in case browser do not support file.type as expected
    const eventFileNameExtension = newFiles[0].name.toLowerCase().endsWith('.csv');
    setIsValidExtension(eventFileType || eventFileNameExtension);
  };

  const handleAddFile = (event) => {
    const { files } = event.target;
    if (files.length > 0) {
      const newFiles = Array.from(files);
      // even our input allows only one file, we still receive a file array in the event
      setDroppedFile(newFiles[0]);
      // validate file type
      setIsValidExtension(newFiles[0].type.includes('text/csv'));
    }
  };

  //   handleDragOver describes case dragging file over the drop area and allow to change background color
  const handleDragOver = (event) => {
    event.preventDefault();
    event.stopPropagation();
    setFileOverBox(true);
  };

  //   handleDragLeave describes case when user dragging file out of the drop area
  const handleDragLeave = (event) => {
    event.preventDefault();
    event.stopPropagation();
    setFileOverBox(false);
  };

  //   delete file that was not saved yet, reset the states
  const handleDeleteFile = () => {
    setDroppedFile(null);
    setIsValidExtension(false);
    setIsDisabled(true);
    setFileOverBox(false);
  };

  return (
    <div
      className="pl-3 h-21.25"
      onDrop={handleDrop}
      onDragOver={handleDragOver}
      onDragEnter={handleDragOver}
      onDragLeave={handleDragLeave}
    >
      {droppedFile
        ? (
          <div className="flex">
            {isValidExtension
              ? <CompletedTrue color={tailwindTheme.theme.extend.colors['vamos-green1']} />
              : <CompletedFalse color={tailwindTheme.theme.extend.colors['vamos-red']} />}
            <div className=" pl-1.25 pr-2.5 space-y-2 items-top">
              <div className="flex">
                <p className="line-clamp-3 break-all">{droppedFile.name}</p>
              </div>
              {!isValidExtension && <p className="text-sm items-left text-vamos-red">Invalid file type. Save your file as a <br />CSV and try again.</p>}
            </div>
            <button type="button" aria-label="delete file" onClick={handleDeleteFile} className="w-6 h-6 flex-shrink-0">
              <Icon name="delete" />
            </button>
          </div>
        )
        : (
          <div className={`${fileOverBox ? 'bg-vamos-green3' : 'bg-vamos-white'} border border-dashed border-vamos-gray rounded-md h-full`}>
            <div className="flex items-center justify-center flex-col space-y-1.75 h-full">
              <div>
                {/* hidden input that allows to choose file */}
                <input
                  type="file"
                  hidden
                  id="choose-file"
                  onChange={handleAddFile}
                  accept=".csv"
                  aria-label="choose file"
                />
                <label htmlFor="choose-file" className="flex items-center gap-2 text-sm font-bold text-vamos-green4 cursor-pointer"><Icon name="download_green" />Choose a CSV File</label>
              </div>
              <p className="text-10">or drag and drop here</p>
            </div>
          </div>
        )}
    </div>
  );
};

ImportChooseFileArea.propTypes = {
  droppedFile: PropTypes.object.isRequired,
  setDroppedFile: PropTypes.func.isRequired,
  isValidExtension: PropTypes.bool.isRequired,
  setIsValidExtension: PropTypes.func.isRequired,
  setIsDisabled: PropTypes.func.isRequired,
};

export default ImportChooseFileArea;
